<template>
  <CreateUpdateUserForm />
</template>

<script setup lang="ts"></script>
